import { ToastType } from '@components/toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { getApiErrorMessage } from '@utils/getApiErrorMessage';
import { enqueueSnackbar } from 'notistack';

export const useDeleteNote = () => {
  const queryClient = useQueryClient();
  const client = useClient();
  const result = useMutation({
    mutationFn: ({ noteId }: { noteId: string }) => client.delete(`note/${noteId}`, {}),
    onMutate: async () => {
      queryClient.invalidateQueries({ queryKey: ['notes'] });
    },
    onError: async (e) => {
      const message = await getApiErrorMessage(e, 'Unable to delete note');
      enqueueSnackbar(message, {
        preventDuplicate: true,
        variant: ToastType.Error,
      });
    },
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ['notes'] });
    },
  });
  return { ...result, deleteNote: result.mutateAsync };
};
